export const environment = {
  name: 'dev',
  version: require('../../build-number.json').buildNumber,
  production: false,
  logLevel: 'debug',
  serverUri: 'https://dev-dt.odyssey.energy/',
  dataServerUri: 'https://dev-data.odyssey.energy',
  dataIngestUri: 'http://localhost:8020',
  zohoSyncUri: 'http://localhost:8023',
  evalServerUri: 'https://dev-eval.odyssey.energy/',
  analytics: 'https://dev-analytics.odyssey.energy',
  apmServerUrl: 'https://dev-2023.apm.us-central1.gcp.cloud.es.io',
  openProjectUri: 'https://dev-tracker.odyssey.energy',
  dashboardBuilderUrl: 'https://qa-dashboard-builder.odyssey.energy',
  cdnUri: 'https://d284j5xinimwah.cloudfront.net/project-group-images/',
  organizationCdnUri: 'https://d284j5xinimwah.cloudfront.net/organization-images',
  apiVersion: '1.0.0',
  hotKey: '5ab24-744be-fafb3-27431-98435',
  mixpanel: {
    projectId: '80e00fb14f8a16fc62f6086b1297a6fd'
  },
  keycloak: {
    issuer: 'https://dev-auth.odyssey.energy/auth/realms/odyssey',
    url: 'https://dev-auth.odyssey.energy',
    realm: 'odyssey',
    theme: 'dt-ui' // default theme
  },
  firebase: {
    apiKey: 'AIzaSyCvzq1E71g5osOoUlbuLrtJY4zdVDKey8A',
    authDomain: 'oes-dt-dev.firebaseapp.com',
    databaseURL: 'https://oes-dt-dev.firebaseio.com',
    firestoreFunctionsBaseUrl: 'https://us-central1-oes-dt-dev.cloudfunctions.net',
    projectId: 'oes-dt-dev',
    storageBucket: 'oes-dt-dev.appspot.com',
    messagingSenderId: '157290518312'
  },
  oio: {
    // No OIO (pipeline-manager) deployment is known for the dev environment. An
    // empty base URL keeps the 'Create via OIO' entry point hidden rather than
    // offering a wizard that cannot reach a backend - fill this in if one lands.
    pipelineManagerBaseUrl: '',
    rmcBackendApiUrl: 'https://dev-dt.odyssey.energy'
  },
};
